module.exports = __webpack_public_path__ + "static/media/smile-plus.66e7709f.svg";